import AddLocationDialog, { AddLocationFormData } from "@components/Locations/AddLocationDialog";
import { useDialog } from "@hooks/useDialog";
import { Location } from "types";

export function useAddLocation({ onSuccess }: { onSuccess?: (locationId: string) => void } = {}) {
    const { openDialog, closeDialog } = useDialog();

    const openLocationAddDialog = (location?: Location) => {
        openDialog({
            title: location ? "Update Location" : "Add Location",
            showActions: false,
            customContent: (
                <AddLocationDialog
                    location={location}
                    onSuccess={(locationId) => {
                        if (onSuccess) onSuccess(locationId)
                        else closeDialog();
                    }}
                />
            ),
        });
    };

    return { openLocationAddDialog };
}

export type { AddLocationFormData };
